enum AddFacilitatorsType {
  AddExistingFacilitators = 'ADD_EXISTING_FACILITATORS',
  InviteNewFacilitators = 'INVITE_NEW_FACILITATORS',
}

export default AddFacilitatorsType;
